export function getBaseUrl(): string {
    return document.querySelector('base')?.getAttribute('href')?.replace(/\/+$/, '') || '/';
}
